import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import UserCarService from "../../apiServices/UserCarService";
import {List, Radio} from 'antd-mobile'
import { createForm } from 'rc-form';
import BottomPanel from "../../components/BottomPanel";
import {TextField} from "react-md";
import {notification} from "antd";
import * as _ from "lodash";
import InsuBrandService from "../../apiServices/InsuBrandService";

const RadioItem = Radio.RadioItem;

class UpdateCarInfo extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('id');
        const buynow = urlParams.get('buynow');
        const update = urlParams.get('update');

        this.state = {
            height: props.height,
            hasError: false,
            hasPlateNumber: 1,
            plate_number: '',
            chassis_number: '',
            engine_number: '',
            objectId: object_id,
            objectType: 'CAR',
            hiddenBtn: false,
            order_id: null,
            insList: [],
            insurance_id: 0,
            buynow: buynow,
            update: update,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});

        InsuBrandService.listBrand().then(response => {
            this.setState({insList: response.data});
        }).catch(function(error){
            console.log(error);
        });
    }

    insBrandSelect = (value) => {
        this.setState({insurance_id: value});
    };

    formSubmit = () => {
        if (this.state.hasPlateNumber===1 && this.state.plate_number===''){
            notification['error']({
                message: 'Bạn chưa nhập biển số xe',
                description: '',
            });
        }else if (this.state.chassis_number === ''){
            notification['error']({
                message: 'Bạn chưa nhập số khung',
                description: '',
            });
        }else if (this.state.engine_number === ''){
            notification['error']({
                message: 'Bạn chưa nhập số máy',
                description: '',
            });
        }else{
            UserCarService.update({
                'id': this.state.objectId,
                'plate_number': this.state.plate_number,
                'chassis_number': this.state.chassis_number,
                'engine_number': this.state.engine_number,
                'insurance_id': this.state.insurance_id,
            }).then(response => {
                this.setState({hiddenBtn: true});
                if (this.state.buynow===1) {
                    this.props.history.push('/mua-bao-hiem?object_id='+this.state.objectId);
                }else{
                    notification['success']({message: 'Lưu thông tin xe thành công', description: '',});
                    this.props.history.push('/chi-tiet-xe?id='+this.state.objectId);
                }
            }).catch(error => {
                notification.error({
                    message: error,
                    description: _.get(error, 'Lỗi lưu thông tin', 'Error'),
                });
            });
        }
    };

    render() {

        let InputPlateNumber;

        if(this.state.hasPlateNumber===1){
            InputPlateNumber = (<div>
                <TextField
                    id="plate_number"
                    label="Biển số"
                    lineDirection="center"
                    placeholder=""
                    className="md-cell md-cell--12"
                    onChange={e => this.setState({plate_number: e})}
                />
            </div>);
        }

        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} title="Cập nhật thông tin xe" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content">
                        <List>
                            <RadioItem key='1' checked={this.state.hasPlateNumber === 1} onChange={e => this.setState({hasPlateNumber: 1})}>
                                Xe đã có biển số
                            </RadioItem>
                            <RadioItem key='2' checked={this.state.hasPlateNumber === 2} onChange={e => this.setState({hasPlateNumber: 2})}>
                                Xe chưa có biển số
                            </RadioItem>
                        </List>

                        {InputPlateNumber}

                        <TextField
                            id="chassis_number"
                            label="Số khung"
                            lineDirection="center"
                            placeholder=""
                            className="md-cell md-cell--12"
                            onChange={e => this.setState({chassis_number: e})}
                        />

                        <TextField
                            id="engine_number"
                            label="Số máy"
                            lineDirection="center"
                            placeholder=""
                            className="md-cell md-cell--12"
                            onChange={e => this.setState({engine_number: e})}
                        />

                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Gửi thông tin"} actionType='submit' />
            </div>
        )
    }
}

UpdateCarInfo = createForm()(UpdateCarInfo);

export default (withTranslation())(UpdateCarInfo);